import React from 'react'
import UsersIndex from '../features/users'

function UsersPage() {
    return (
        <UsersIndex />
  )
}

export default UsersPage